import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { colors } from '@/lib/analytics/colors';
import { SIZE_50 } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { KPI_VALUE_PERCENT } from '@/utils/hooks/format/useFormatKpiValue';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const avgEngagementRateOnImpressionsConfig: KpiType<
    typeof DefaultLoader,
    typeof KPIDefault
> = {
    name: 'kpi.pinterest.average_engagement_rate_on_impressions',
    id: 'average_engagement_rate_on_impressions',
    icon: {
        name: 'engagement-on',
        style: colors.green
    },
    tooltip: 'kpi.pinterest.tooltip_average_engagement_rate_on_impressions',
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_PERCENT,
    size: SIZE_50,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    noDataToken: 'analytics:no_data_period',
    element: KPIDefault,
    loader: DefaultLoader
};
